// extracted by mini-css-extract-plugin
module.exports = {"unChatLock":"ChatDownIcon_unChatLock__3gJWz"};